import { LoadingButton } from '@mui/lab';
import { Alert, Box, Container } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { api } from 'src/Api';
import Page from 'src/components/Page';
import QuillRichText from 'src/components/QuillRichText';

export default function PrivacyPolicy() {
  const [loading, setloading] = useState(false);
  const [gettoken, setGettoken] = useState('');
  const [editid, seteditId] = useState('');
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [value, setValue] = useState('');
  useEffect(() => {
    const token = localStorage.getItem('token');
    setGettoken(token);
    if (gettoken) {
      GetContent();
      // console.log('token avaliable');
    }
  }, [gettoken]);

  function GetContent() {
    console.log('token', gettoken);
    var myHeaders = new Headers();
    myHeaders.append('Authorization', 'Bearer ' + gettoken);

    const params = new URLSearchParams();
    params.append('type', 'privacy_policy');

    let url = `${api.get_contents}?${params.toString()}`;
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      // body: formdata,
      redirect: 'follow'
    };

    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          return response.text();
        } else {
          return response.json().then((result) => {
            console.log('result+++++policy', result?.error);
            if (result?.error) {
              setalert({ visible: true, message: result.error });
            }
          });
        }
      })
      .then((result) => {
        const res = JSON.parse(result);
        console.log('result ======', res);
        // const res = result?.[data];
        setValue(res.data[0]?.content);
        seteditId(res.data[0]?.id);
      })
      .catch((error) => {
        console.log('error======', error);
      })
      .finally(() => {
        setloading(false);
      });
  }

  function handlerEdit() {
    setloading(true);
    const token = localStorage.getItem('token');
    var myHeaders = new Headers();
    myHeaders.append('Authorization', 'Bearer ' + token);

    var formdata = new FormData();
    formdata.append('content', value);
    formdata.append('type', 'privacy_policy');
    formdata.append('id', editid);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.edit_content, requestOptions)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          setalert({ visible: false });
          return response.text();
        } else {
          return response.json().then((result) => {
            setalert({ visible: true, message: result.error });
          });
        }
      })
      .then((result) => {
        console.log('result ======', result);
      })
      .catch((error) => {
        console.log('error======', error);
      })
      .finally(() => {
        setloading(false);
      });
  }

  return (
    <Page title={`Privacy Policy | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <div style={{ padding: '2rem' }}>
          <QuillRichText defaultValue={value} value={value} onChange={(value) => setValue(value)} />
          <LoadingButton
            disabled={false}
            loading={loading}
            sx={{
              marginTop: '8%'
            }}
            onClick={handlerEdit}
            color="primary"
            variant="contained"
          >
            Save
          </LoadingButton>
          <Box mt={2}>
            {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
          </Box>
        </div>
      </Container>
    </Page>
  );
}
